export const hasError = (visited, error) => Boolean(visited && error);
